import { Option } from '@storeblocks/radio';
import { RadioButton } from 'Components/FormFields/RadioButton';
import React from 'react';
import { getAppText } from 'Utils/text';

interface CancelReasonProps {
  disabled: boolean;
  options: Option[];
  onChange?: (event: string) => void;
}

export const CancelReason = ({
  disabled,
  options,
  onChange,
}: CancelReasonProps): React.ReactElement => {
  return (
    <RadioButton
      id="cancelReason"
      name="cancelReason"
      label={getAppText('cancel.cancelReason.label')}
      disabled={disabled}
      options={options}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
      }}
    />
  );
};
